'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Mapping from pluralRule mnemonic name to indexing function
var pluralTypes = {
  chineseLike: function () {
    function chineseLike() {
      return 0;
    }

    return chineseLike;
  }(),
  germanLike: function () {
    function germanLike(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // everything else
      return 1;
    }

    return germanLike;
  }(),
  frenchLike: function () {
    function frenchLike(n) {
      // is 0 or 1
      if (n <= 1) {
        return 0;
      }
      // everything else
      return 1;
    }

    return frenchLike;
  }(),
  russianLike: function () {
    function russianLike(n) {
      // ends in 1, excluding 11
      if (n % 10 === 1 && n % 100 !== 11) {
        return 0;
      }
      // ends in 2-4, excluding 12-14
      if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return 1;
      }
      // everything else
      return 2;
    }

    return russianLike;
  }(),
  czechLike: function () {
    function czechLike(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // is 2-4
      if (n >= 2 && n <= 4) {
        return 1;
      }
      // everything else
      return 2;
    }

    return czechLike;
  }(),
  polishLike: function () {
    function polishLike(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // ends in 2-4, excluding 12-14
      if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return 1;
      }
      // everything else
      return 2;
    }

    return polishLike;
  }(),
  icelandicLike: function () {
    function icelandicLike(n) {
      // ends in 1, excluding 11
      if (n % 10 === 1 && n % 100 !== 11) {
        return 0;
      }
      // everything else
      return 1;
    }

    return icelandicLike;
  }(),
  arabicLike: function () {
    function arabicLike(n) {
      // is 0
      if (n === 0) {
        return 0;
      }
      // is 1
      if (n === 1) {
        return 1;
      }
      // is 2
      if (n === 2) {
        return 2;
      }
      // ends in 03-10
      if (n % 100 >= 3 && n % 100 <= 10) {
        return 3;
      }
      // everything else but is 0 and ends in 00-02, excluding 0-2
      if (n % 100 >= 11) {
        return 4;
      }
      // everything else
      return 5;
    }

    return arabicLike;
  }(),
  irish: function () {
    function irish(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // is 2
      if (n === 2) {
        return 1;
      }
      // is 3-6
      if (n >= 3 && n <= 6) {
        return 2;
      }
      // is 7-10
      if (n >= 7 && n <= 10) {
        return 3;
      }
      // everything else
      return 4;
    }

    return irish;
  }(),
  latvianLike: function () {
    function latvianLike(n) {
      // ends in 0
      if (n % 10 === 0) {
        return 0;
      }
      // ends in 1, excluding 11
      if (n % 10 === 1 && n % 100 !== 11) {
        return 1;
      }
      // everything else
      return 2;
    }

    return latvianLike;
  }(),
  lithuanian: function () {
    function lithuanian(n) {
      // ends in 1, excluding 11
      if (n % 10 === 1 && n % 100 !== 11) {
        return 0;
      }
      // ends in 2-9, excluding ending in 12-19
      if (n % 10 >= 2 && !(n % 100 >= 12 && n % 100 <= 19)) {
        return 1;
      }
      // everything else
      return 2;
    }

    return lithuanian;
  }(),
  maltese: function () {
    function maltese(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // is 0 or ends in 01-10, excluding 1
      if (n === 0 || n !== 1 && n % 100 >= 1 && n % 100 <= 10) {
        return 1;
      }
      // ends in 11-19
      if (n % 100 >= 11 && n % 100 <= 19) {
        return 2;
      }
      // everything else
      return 3;
    }

    return maltese;
  }(),
  romanian: function () {
    function romanian(n) {
      // is 1
      if (n === 1) {
        return 0;
      }
      // is 0 or ends in 01-19, excluding 1
      if (n === 0 || n !== 1 && n % 100 >= 1 && n % 100 <= 19) {
        return 1;
      }
      // everything else
      return 2;
    }

    return romanian;
  }(),
  slovenianLike: function () {
    function slovenianLike(n) {
      // ends in 01
      if (n % 100 === 1) {
        return 0;
      }
      // ends in 02
      if (n % 100 === 2) {
        return 1;
      }
      // ends in 03-04
      if (n % 100 === 3 || n % 100 === 4) {
        return 2;
      }
      // everything else
      return 3;
    }

    return slovenianLike;
  }(),
  tagalog: function () {
    function tagalog(n) {
      // ends in 0, 1, 2, 3, 5, 7, 8
      if (n % 10 !== 4 && n % 10 !== 6 && n % 10 !== 9) {
        return 0;
      }
      // everything else
      return 1;
    }

    return tagalog;
  }()
};

// Mapping from pluralization group to individual language codes/locales.
// Will look up based on exact match, if not found and it's a locale will parse the locale
// for language code, and if that does not exist will default to 'en'
var pluralTypeToLanguages = {
  chineseLike: ['az', 'id', 'ja', 'ko', 'ms', 'th', 'tr', 'vi', 'zh', 'zh-TW'],
  germanLike: ['bg', 'ca', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'he', 'hu', 'it', 'ka', 'nl', 'no', 'pt', 'sq', 'sv', 'sw', 'xh', 'zu'],
  frenchLike: ['fr', 'hi', 'hy'],
  russianLike: ['bs', 'hr', 'ru', 'sr', 'uk'],
  czechLike: ['cs', 'sk'],
  polishLike: ['pl'],
  icelandicLike: ['is', 'mk'],
  arabicLike: ['ar'],
  irish: ['ga'],
  latvianLike: ['lv'],
  lithuanian: ['lt'],
  maltese: ['mt'],
  romanian: ['ro'],
  slovenianLike: ['sl'],
  tagalog: ['tl']
};

exports['default'] = { pluralTypes: pluralTypes, pluralTypeToLanguages: pluralTypeToLanguages };
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-i18n/pluralRules.js
// module id = 454
// module chunks = 168707334958949